module.exports = __webpack_public_path__ + "img/tourism_typography.985c0a25.webp";